import { render } from "./AppHeaderDropdownAccnt.vue?vue&type=template&id=935d3364"
import script from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lykaon/gitlykaon/people-measurement-system.webapp-prestaging/cloud/pms_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__